import { createAction } from '@reduxjs/toolkit';

/** ... */
export const resetStore = createAction<void>('resetStore');
